import React, {useMemo} from 'react';

import Teaser from '~/src/components/teaser/Teaser';

import {GetNextSideline} from '~/src/utilities/helpers/sidelineStack';
import {getNextCounter} from '~/src/utilities/helpers/counters';
import {getAdUnitName} from '~/src/utilities/helpers/ad';

interface SidelineItemProps {
    adUnit: string;
    getNextSideline: GetNextSideline;
}

export const SidelineItem: React.FC<SidelineItemProps> = ({adUnit, getNextSideline}) => {
    const teaserProps = useMemo(() => {
        const adUnitName = getAdUnitName(adUnit, getNextCounter(adUnit));
        return getNextSideline(adUnitName);
    }, []);

    return <Teaser {...teaserProps} />;
};
